export const blockIconsHomeToolsPowerDrillNew = (
	<span className='material-symbols-outlined'>tools_power_drill</span>
);
